import { render, staticRenderFns } from "./ChamadoDashboard.vue?vue&type=template&id=beeb1042&scoped=true"
import script from "./ChamadoDashboard.vue?vue&type=script&lang=js"
export * from "./ChamadoDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beeb1042",
  null
  
)

export default component.exports